// EarningsDisclaimer — reusable FTC-facing disclosure for the Partner Program.
// Copy supplied by Randy; [Platform Name] resolved to "My Silo".
//   - "short"  → buttons / cards / pop-ups (tight on space)
//   - "full"   → wherever the Partner Program / referral benefits are explained
//   - "footer" → landing footer / Terms of Service catch-all
//
// NOTE (legal): this is generic disclosure language, not legal advice. Final
// wording should be confirmed by counsel before scaling.
import { Info } from "@phosphor-icons/react";

const COPY = {
  short:
    "Commission Disclaimer: Participation in the My Silo Partner Program does not guarantee income. Commissions are paid only on successful software sales. Individual results will vary.",
  full:
    "Earnings Disclaimer: The My Silo Partner Program is designed for users who wish to share our tools with others. Commissions are based solely on the sale of My Silo software products. Results vary; most users do not earn significant income, and success depends entirely on your own marketing efforts and the quality of your referrals. There is no guarantee of income.",
  footer:
    "Earnings Disclosure: My Silo does not guarantee that you will earn any money by participating in our Partner Program. Any potential earnings shown or discussed are estimates based on successful conversions of software sales and are not typical. Your success depends on your own effort, audience, and ability to market our tools to others. No income is promised or implied.",
};

export default function EarningsDisclaimer({ variant = "short", className = "" }) {
  const text = COPY[variant] || COPY.short;
  return (
    <p
      data-testid={`earnings-disclaimer-${variant}`}
      className={`text-[10px] leading-relaxed text-[#8A8A82] flex items-start gap-1.5 ${className}`}
    >
      <Info size={11} weight="duotone" className="shrink-0 mt-0.5" />
      <span>{text}</span>
    </p>
  );
}
